import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/chat/calendar.svg'
import _imports_1 from '../../assets/chat/arrow_down.svg'
import _imports_2 from '../../assets/chat/arrow_up.svg'


const _withScopeId = n => (_pushScopeId("data-v-3efdbf72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "datePicker" }
const _hoisted_2 = { class: "dateTwoPicker" }
const _hoisted_3 = { class: "imgAndDrop" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "calendar"
}, null, -1))
const _hoisted_5 = { class: "el-dropdown-link" }
const _hoisted_6 = { class: "selectedDate" }
const _hoisted_7 = {
  key: 0,
  class: "imgBox"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "arrow_down"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "imgBox"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "arrow_down"
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]

import { ref, watch, computed, nextTick, h, shallowRef, onMounted } from "vue";
import { dateFormat, gaEvent } from "@/utils/format";
import moment from "moment";
import { useI18n } from "vue-i18n";
import { event } from "vue-gtag";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'datePicker',
  props: {
  syncLoading: {
    type: Boolean,
  },
  isSevenDay: {
    type: Boolean,
  },
  isScreenTime: {
    type: Boolean,
    default: false
  }
},
  emits: ["change"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const all = computed(() => t("chat.all"));

const emit = __emit;
var picker = ref(null);
const range = ref([]);
const store = useStore();
const props = __props
const isVibe = computed(() => store.state.isVibe);
const isShowMore750 = computed(() => store.state.isShowMore750);
// const dateValue1 = ref()
// 下拉选项
const selectOptions: any[] = [
  {
    label: `chat.all`,
    value: () => {
      // 获取当前时间+12个月的时间
      const end = moment().add(12, "M").format("X");
      // const start = "1609430400"; // 2021.01.01 00:00:00
      const start = "1"; // 1949.10.01 00:00:00
      return [start, end];
    },
  },
  {
    label: `chat.today`,
    value: () => {
      const end = moment().endOf("day").format("X"); // 当天的起始时间戳（单位：s）
      const start = moment().startOf("day").format("X"); // // 当天的结束时间戳（单位：s）
      return [start, end];
    },
  },
  {
    label: "chat.yesterday",
    value: () => {
      const end = moment()
        .day(moment().day() - 1)
        .endOf("day")
        .format("X");
      const start = moment()
        .day(moment().day() - 1)
        .startOf("day")
        .format("X");
      return [start, end];
    },
  },
  {
    label: `chat.last7Days`,
    value: () => {
      const end = moment().format("X");
      const start = moment().subtract("days", 6).format("X");
      return [start, end];
    },
  },
  {
    label: "chat.last30Days",
    value: () => {
      const end = moment().format("X");
      const start = moment().subtract("days", 29).format("X");
      return [start, end];
    },
  },
  // {
  //   label: 'chat.customRange',
  //   value: () => {
  //     return 'custom'
  //   },
  // },
];

const selectedValue = ref<any>(`chat.all`);
const currLabel = ref("chat.all");
const customPrefix = shallowRef({
  render() {
    return h("img", {
      src: require("@/assets/chat/predate-icon.svg"),
    });
  },
});
const endAdd12: any = parseInt(moment().add(12, "M").format("X")) * 1000;
// 1609430400000, endAdd12
const pickerValue = ref<[any, any]>([]);

const defaultTime = ref([
  new Date(2022, 1, 1, 0, 0, 0),
  new Date(2022, 2, 1, 23, 59, 59),
]);

const currTimeStamp = ref([]);

// 日历组件值改变时触发
const pickerChange = (value: any) => {
  if (!isVibe.value) {
    pickerValue.value = "";
    ElMessage.error(t("chat.noSupportToast"));
    return;
  }
  if (!pickerValue.value[0] || !pickerValue.value[1]) return
  console.log("pickerValue[1]:", pickerValue.value[1], pickerValue.value[0]);

  if (!value || value.length == 0) {
    if (selectedValue.value == `chat.all`) {
      // 发出事件，重新请求全部的数据
      emit("change", selectOptions[0].value());
    } else {
      selectedValue.value = `chat.all`;
    }

    return;
  }
  console.log(('pickerChange1'), value);
  if (props.isScreenTime) {
    const startaaa = computeDays(pickerValue.value[0], pickerValue.value[1])
    gaEvent("ScreenTime_Date", {
      event_category: "ScreenTime",
      event_label: startaaa + 1,
    });
  }
  // console.log(value, value[0].getTime(), value[1].getTime(), 'value');
  const rangeTime = [
    (pickerValue.value[0].getTime() / 1000).toFixed(0),
    (pickerValue.value[1].getTime() / 1000).toFixed(0),
  ];
  emit("change", rangeTime);
};


// 计算自定义时间筛选选中的天数
const computeDays = (startDay: any, endDay: any) => {
  const startDate = new Date(startDay);
  const endDate = new Date(endDay);

  // 将日期对象转换为时间戳（以毫秒为单位）
  const startTimeStamp = startDate.getTime();
  const endTimeStamp = endDate.getTime();

  // 计算时间戳差值（以毫秒为单位）
  const timeDiff = endTimeStamp - startTimeStamp;

  // 将毫秒转换为天数（1天 = 24小时 * 60分钟 * 60秒 * 1000毫秒）
  const daysDiff = Math.floor(timeDiff / (24 * 60 * 60 * 1000));
  return daysDiff
}

// 日历面板出现或隐藏时触发
const pickerVisibleChange = (isVisible: boolean) => {
  // if (isVisible) {
  //   // console.log('显示');
  //   const footerBtns = document.querySelectorAll('.el-picker-panel__footer > button');
  //   // console.log(footerBtns, 'footerBtns', footerBtns[1].querySelector('span'));
  //   (footerBtns[0].querySelector('span') as any).innerText = t('chat.cancel');
  //   (footerBtns[1].querySelector('span') as any).innerText = t('chat.apply');
  //   (footerBtns[1] as any).classList.add('applyBtn');
  //   (footerBtns[0] as any).classList.add('cancelBtn');
  // }
};

// 下拉列表选项点击时触发
const handleItemClick = (item: any, isFirst: Boolean = false) => {
  // console.log(item, 'handleItemClick');

  if (!isVibe.value) {
    if (typeof isFirst == 'object') {
      ElMessage.error(t("chat.noSupportToast"));
    }
    return;
  }
  const msTimeStamp = item.value().map((i: any) => i * 1000);
  // pickerValue.value = msTimeStamp
  currLabel.value = item.label;
  if (item.label.indexOf("all") == -1) {
    // 排除点击全部，除了点击全部选项，都需要进行埋点上报
    pickerValue.value = msTimeStamp;
    const timeValue = item.label.split(".")[1];
    const newTimeValue = timeValue[0].toUpperCase() + timeValue.substr(1);
    // console.log(newTimeValue, 'timeValue');
    if (props.isScreenTime) {
      gaEvent("ScreenTime_Date", {
        event_category: "ScreenTime",
        event_label: newTimeValue,
      });
    }
  } else {
    // 选择全部时，左侧日历组件不展示具体的日期时间
    pickerValue.value = [];

    if (props.isScreenTime) {
      gaEvent("ScreenTime_Date", {
        event_category: "ScreenTime",
        event_label: 'All',
      });
    }
  }

  if (item.label == selectedValue.value) {
    // 如果当前点击选中项和原本的激活项一样，则手动emit change事件调接口更新数据
    let valueFn: any;
    for (let i = 0; i < selectOptions.length; i++) {
      if (selectOptions[i].label == selectedValue.value) {
        valueFn = selectOptions[i].value;
        break;
      }
    }
    let rangeTime = valueFn();
    // console.log(rangeTime, 'rangeTime')
    if (rangeTime != "custom") {
      emit("change", rangeTime);
    }
  }
  selectedValue.value = item.label;
};

// 下拉框出现/隐藏时触发
const isVisible = ref(false);
const handleDropVisible = (isShow: boolean) => {
  isVisible.value = isShow;
};

// 监听selectedValue值的改变，只要改变就向父级发出事件，传递当前选中的时间范围值
watch(
  [selectedValue],
  () => {
    console.log('selectedValue发生了改变', selectedValue.value);
    let valueFn: any;
    for (let i = 0; i < selectOptions.length; i++) {
      if (selectOptions[i].label == selectedValue.value) {
        valueFn = selectOptions[i].value;
        break;
      }
    }

    let rangeTime = valueFn();
    // console.log(rangeTime, 'rangeTime')
    if (rangeTime != "custom") {
      emit("change", rangeTime, selectedValue.value);
    }
  },
  // { immediate: true }
);

// 针对阿拉伯语的样式处理
const currentLang = computed(() => store.state.currentLang);
watch(isVisible, (newVal, oldVal) => {
  try {
    if (isVisible.value && currentLang.value == "ar") {
      nextTick(() => {
        const rightTexts = document.querySelectorAll(
          ".el-dropdown-menu__item"
        ) as any;
        for (const i of rightTexts) {
          i.style.justifyContent = "flex-end";
        }
      });
    }
  } catch (err) {
    console.log(err);
  }
});
// watch(() => props.syncLoading, () => {
//   console.log('点击了同步时间要变化了', selectedValue.value);
//   let valueFn: any;
//   for (let i = 0; i < selectOptions.length; i++) {
//     if (selectOptions[i].label == selectedValue.value) {
//       valueFn = selectOptions[i].value;
//       break;
//     }
//   }
//   let rangeTime = valueFn();
//   // console.log(rangeTime, 'rangeTime')
//   if (rangeTime != "custom") {
//     emit("change", rangeTime);
//   }
// })
onMounted(() => {
  if (isVibe.value) {
    if (props.isSevenDay) {
      handleItemClick({
        label: `chat.last7Days`,
        value: () => {
          const end = moment().endOf('day').format("X");
          const start = moment().subtract("days", 6).startOf('day').format("X");
          return [start, end];
        },
      }, true)
    } else {
      handleItemClick({
        label: `chat.all`,
        value: () => {
          // 获取当前时间+12个月的时间
          const end = moment().add(12, "M").format("X");
          // const start = "1609430400"; // 2021.01.01 00:00:00
          const start = "1"; // 1949.10.01 00:00:00
          return [start, end];
        },
      }, true)

    }

    console.log(" moment().format:", moment().subtract("days", 6).startOf('day').format("X"));
    console.log(" moment().format:", moment().endOf('day').format("X"));
  }


})
// el-picker-panel__footer

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_el_date_picker, {
        modelValue: pickerValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pickerValue).value = $event)),
        "default-time": defaultTime.value,
        type: "daterange",
        "range-separator": "一",
        "start-placeholder": _ctx.$t('chat.startDate'),
        "end-placeholder": _ctx.$t('chat.endDate'),
        style: {"margin-right":"21px"},
        editable: false,
        onChange: pickerChange,
        onVisibleChange: pickerVisibleChange,
        format: "YYYY-MM-DD",
        "prefix-icon": customPrefix.value
      }, null, 8, ["modelValue", "default-time", "start-placeholder", "end-placeholder", "prefix-icon"])
    ], 512), [
      [_vShow, isShowMore750.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_date_picker, {
        modelValue: pickerValue.value[0],
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pickerValue.value[0]) = $event)),
        type: "date",
        placeholder: _ctx.$t('chat.startDate'),
        onChange: pickerChange,
        editable: false
      }, null, 8, ["modelValue", "placeholder"]),
      _createVNode(_component_el_date_picker, {
        modelValue: pickerValue.value[1],
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((pickerValue.value[1]) = $event)),
        type: "date",
        placeholder: _ctx.$t('chat.endDate'),
        onChange: pickerChange,
        editable: false
      }, null, 8, ["modelValue", "placeholder"])
    ], 512), [
      [_vShow, !isShowMore750.value]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_el_dropdown, {
        trigger: "click",
        onCommand: handleItemClick,
        onVisibleChange: handleDropVisible
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(selectOptions, (item) => {
                return _createVNode(_component_el_dropdown_item, {
                  key: item.value,
                  command: item,
                  class: _normalizeClass([[currLabel.value == item.label ? 'item_active' : ''], "dropItem"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(item.label)), 1)
                  ]),
                  _: 2
                }, 1032, ["command", "class"])
              }), 64))
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t(selectedValue.value)), 1),
            (!isVisible.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})